//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
SPLM.Diagramming.Axis = Object.freeze({
    "X" : "X", "Y" : "Y"});

SPLM.Diagramming.Direction = Object.freeze({
    "In" : "In", "Out" : "Out", "Both" : "Both"});

SPLM.Diagramming.DiagrammingSizingpolicy = Object.freeze({
    "Length" : "Length", "Auto" : "Auto", "Percent" : "Percent", "Inherit" : "Inherit"});

SPLM.Diagramming.DiagrammingStubsides = Object.freeze({
    "Auto" : "Auto", "Left" : "Left", "Right" : "Right"});

SPLM.Diagramming.DiagrammingAnnotationboundarytype = Object.freeze({
    "None" : "None", "Circle" : "Circle", "Ellipse" : "Ellipse", "Rectangle" : "Rectangle", "RoundedRectangle" : "RoundedRectangle"});

SPLM.Diagramming.DiagrammingGeometrypointmarker = Object.freeze({
    "Cross" : "Cross", "Circle" : "Circle"});

SPLM.Diagramming.DiagrammingArrowtype = Object.freeze({
    "None" : "None", "Open" : "Open", "Filled" : "Filled", "ClosedSolid" : "ClosedSolid"});

SPLM.Diagramming.DiagrammingAlignment = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right", "Justify" : "Justify"});

SPLM.Diagramming.DiagrammingLocationstyle = Object.freeze({
    "Absolute" : "Absolute", "Relative" : "Relative"});

SPLM.Diagramming.DiagrammingJumpertype = Object.freeze({
    "U" : "U", "Break" : "Break"});

SPLM.Diagramming.DiagrammingJumperprioritytype = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

SPLM.Diagramming.DiagrammingConnectionlabelhorizontaloffsetposition = Object.freeze({
    "Above" : "Above", "Below" : "Below"});

SPLM.Diagramming.DiagrammingConnectionlabelverticaloffsetposition = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Diagramming.DiagrammingConnectionlabelposition = Object.freeze({
    "Start" : "Start", "End" : "End", "Center" : "Center", "Spaced" : "Spaced"});

SPLM.Diagramming.DiagrammingRepeatstartposition = Object.freeze({
    "Center" : "Center", "Start" : "Start", "End" : "End"});

SPLM.Diagramming.DiagrammingFlowdirectionarrowstyle = Object.freeze({
    "BottomFilledArrow" : "BottomFilledArrow", "BottomOpenArrow" : "BottomOpenArrow", "ClosedArrow" : "ClosedArrow", "ClosedDoubleArrow" : "ClosedDoubleArrow", "ClosedDoubleSolidArrow" : "ClosedDoubleSolidArrow", "ClosedSolidArrow" : "ClosedSolidArrow", "FilledArrow" : "FilledArrow", "FilledDoubleArrow" : "FilledDoubleArrow", "OpenArrow" : "OpenArrow", "OpenDoubleArrow" : "OpenDoubleArrow", "TopFilledArrow" : "TopFilledArrow", "TopOpenArrow" : "TopOpenArrow"});

export default SPLM;